import React from 'react';
// import TabletIcon from '../../../../../assets/icons/resources/tablet.svg';
import ClockIcon from '../../../../../assets/icons/resources/clock.svg';
import ClockDisabled from '../../../../../assets/icons/resources/clock-disabled.svg';
import CalendarIcon from '../../../../../assets/icons/resources/calendar.svg';
import CalendarDisabled from '../../../../../assets/icons/resources/calendar-disabled.svg';
import {
  CardBody,
  CardContainer,
  CardHeader
} from './ResourceStyledComponents';

interface ResourceCardProps {
  resourceTitle: string;
  icon: any;
  durationText: string;
  onClick?: () => void;
  isDisabled?: boolean;
  inPeriodCurrent?: boolean;
}

const ResourceCard = ({
  resourceTitle,
  icon,
  onClick,
  durationText,
  isDisabled,
  inPeriodCurrent = true
}: ResourceCardProps) => (
  <CardContainer
    onClick={onClick}
    data-testid="cmp-resource-card-reservation"
    disabled={isDisabled}
  >
    <div
      style={{
        marginBottom: isDisabled ? 20 : 0
      }}
    >
      <CardHeader>
        <img src={icon} alt="tableticon" />
        <div className="text">
          <div className="headerTitle">{resourceTitle}</div>
        </div>
      </CardHeader>
      <CardBody disabled={isDisabled}>
        {inPeriodCurrent && isDisabled ? (
          <div
            style={{
              fontSize: '14px',
              color: '#000000',
              lineHeight: '20px',
              fontWeight: '400',
              textAlign: 'left'
            }}
          >
            ¡Disponible en UTP+app!
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', marginBottom: '4px' }}>
              <img
                src={isDisabled ? ClockDisabled : ClockIcon}
                alt="ClockIcon"
              />
              <div>{durationText}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <img
                src={isDisabled ? CalendarDisabled : CalendarIcon}
                alt="CalendarIcon"
              />
              <div>Durante el día</div>
            </div>
          </>
        )}
      </CardBody>
    </div>
  </CardContainer>
);
export default ResourceCard;
